/**
 * Frequently Asked Questions (FAQ) - Archive (listing view)
 */

'use strict';

var ui = require('../misc/layout');

// Constructor
var FrontFaqArchive = function () {
    if (!$('body').hasClass('post-type-archive-cm-faq')) {
        return;
    }

    $(document).ready((function () {
        this.initMaterialize();
        this.initCollapsible();
        this.dropdownCategories();
        this.getPagedOnLoad();
        this.pagination();
    }).bind(this));
};

FrontFaqArchive.prototype = {
    lockAjaxGetResults: false,
    pagedOnLoad: 1,

    initMaterialize: function() {
        $('.page select#category').formSelect();
        $('.page select#subCategory').formSelect();
    },

    /**
     * Initialize the Collapsible Materialize component.
     */
    initCollapsible: function() {
        ui.initCollapsible();
    },

    /**
     * Display a categories and sub-categories selector.
     */
    dropdownCategories: function() {
        var self = this;
        var $selectCategory = $('select#category');
        var $selectSubCategory = $('select#subCategory');

        var setSubCategoryFromCategory = function(idCategory) {
            var sub = [];

            if (idCategory != '') {
                // Remove all options
                $selectSubCategory.find('option').remove();
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.faqDropdownSubCategory,
                    disabled: 'disabled',
                    selected: 'selected',
                }));

                $.each(faq.subCategories, function (i, item) {
                    if (idCategory == item.parent_id) {
                        sub.push({
                            value: item.term_id,
                            text : item.name
                        });
                    }
                });

                // Inset new options
                if (sub.length > 0) {
                    $selectSubCategory.append($('<option>', {
                        value: '',
                        text : comedien.i18n.faqDropdownAll
                    }));

                    $.each(sub, function (i, item) {
                        $selectSubCategory.append($('<option>', {
                            value: item.value,
                            text : item.text
                        }));
                    });
                }
            } else {
                $selectSubCategory.find('option').remove();
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.faqDropdownSubCategory,
                    disabled: 'disabled',
                    selected: 'selected',
                }));
            }

            if (idCategory != '' && sub.length > 0) {
                $selectSubCategory.removeAttr('disabled');
            } else {
                $selectSubCategory.attr('disabled', 'disabled');
            }

            $selectSubCategory.formSelect('destroy');
            $selectSubCategory.formSelect();
        };

        // On option select

        $selectCategory.change(function() {
            var selectedValue = $(this).val();
            setSubCategoryFromCategory(selectedValue);
        });

        // On page load

        if ($selectCategory.val() != '') {
            var selectedValue = $selectCategory.val();
            setSubCategoryFromCategory(selectedValue);

            if (typeof faq.search !== 'undefined' && typeof faq.search.subCategory !== 'undefined') {
                $selectSubCategory.val(faq.search.subCategory);

                // re-initialize the select component
                $selectSubCategory.formSelect('destroy');
                $selectSubCategory.formSelect();
            }
        }

        // On category or subcategory select, fetch the posts
        $selectCategory.change(function() {
            self.showPageResults(1);
        });

        $selectSubCategory.change(function() {
            self.showPageResults(1);
        });
    },

    /**
     * Get the current paged ID (paged) on first page load.
     * Useful when dealing with the popstate event.
     */
    getPagedOnLoad: function() {
        var self = this;

        var pathArray = window.location.pathname.split('/');
        $.each(pathArray, function (i, item) {
            if (item == 'page' && pathArray[i + 1] !== undefined) {
                self.pagedOnLoad = parseInt(pathArray[i + 1]);
                return false;
            }
        });
    },

    /**
     * Handle the pagination links (step 1 of 2).
     */
    pagination: function() {
        var self = this;

        $('main#content .pagination li a').on('click', function() {
            if ($(this).parent().hasClass('disabled')) {
                return;
            }

            // Get the current page
            var paged = 1;
            var pathArray = window.location.pathname.split('/');
            $.each(pathArray, function (i, item) {
                if (item == 'page' && pathArray[i + 1] !== undefined) {
                    paged = parseInt(pathArray[i + 1]);
                }
            });

            // Get the page to load
            var pagedTarget = null;
            if ($(this).hasClass('prev') && paged > 1) {
                pagedTarget = paged - 1;
            } else if ($(this).hasClass('next')) {
                pagedTarget = paged + 1;
            } else if ($(this).hasClass('page')) {
                pagedTarget = parseInt($(this).text());
            }

            if (pagedTarget == paged || pagedTarget == null) {
                return;
            }

            self.showPageResults(pagedTarget);
        });
    },

    /**
     * Handle the pagination links (step 2 of 2).
     * Fetch posts with the given page ID, replace the current posts with the new ones.
     *
     * @param {number} page  The targeted page ID (paged) to load
     */
    showPageResults: function(paged) {
        var self = this;

        if (this.lockAjaxGetResults) {
            // Pending AJAX request... do nothing
            return;
        }

        this.lockAjaxGetResults = true;

        // Display the loading spinner
        $('#results .cm-collapsible').hide();
        $('#results .pagination').hide();
        $('#results #loading').fadeIn();

        // Pagination links
        var paginationLinks = function() {
            $('#results .pagination li').removeClass('active').removeClass('disabled').addClass('waves-effect');
            $('#results .pagination li').each(function() {
                if (parseInt($('.page', this).text()) == paged) {
                    $(this).addClass('active').removeClass('waves-effect');
                }
            });

            var nbPages = Math.ceil(faq.total / faq.postsPerPage);

            if (paged == 1) {
                // First page
                $('#results .pagination li:first-child').removeClass('waves-effect').addClass('disabled');
            } else if (paged == nbPages) {
                // Last page
                $('#results .pagination li:last-child').removeClass('waves-effect').addClass('disabled');
            }

            $('#results .pagination').show();
        };

        // Fetch the posts
        self.ajaxGetResults(function(response) {
            if (response.success) {
                // Hide the loading spinner
                $('#results #loading').fadeOut();

                // Replace the previous posts with the new ones
                $('#results .cm-collapsible').html(response.data.questions).fadeIn();

                // Change the URL with HTML5 history

                var currentUrl = window.location.href;
                var newUrl = '';

                var pathArray = window.location.pathname.split('/');
                $.each(pathArray, function (i, item) {
                    if (item == 'page' && pathArray[i + 1] !== undefined) {
                        var currentPaged = parseInt(pathArray[i + 1]);

                        // The URL is already paginated (the string "/page/X/" was found)
                        if (paged == 1) {
                            // First page targeted: remove the pagination
                            newUrl = currentUrl.replace('page/' + currentPaged, '');
                            if (newUrl.slice(-2) == '//') { // bug fix - change '/faq//' to '/faq/'
                                newUrl = newUrl.substring(0, newUrl.length - 1);
                            }
                        } else {
                            // We just have to replace the page number
                            newUrl = currentUrl.replace('page/' + currentPaged, 'page/' + paged);
                        }

                        return false;
                    }
                });

                if (newUrl == '') {
                    // The URL is not paginated (the string "/page/X/" was NOT found)
                    // Append this string, with the targeted page number, in the URL
                    newUrl = currentUrl + 'page/' + paged + '/';
                }

                if (newUrl.slice(-7) == 'page/1/') {
                    // Workaround
                    newUrl = newUrl.replace('page/1/', '');
                }

                var stateObj = { faq: true, paged: paged };
                var pageTitle = $(document).attr('title');

                history.pushState(stateObj, pageTitle, newUrl);
            } else {
                console.log('An error occured!');
            }

            paginationLinks();

            self.lockAjaxGetResults = false;
        }, function(jqXHR, textStatus) {
            paginationLinks();

            self.lockAjaxGetResults = false;
            console.log("Request failed: " + textStatus);
        }, paged);

        // HTM5 history - Handle the back button

        window.addEventListener('popstate', function(event) {
            var prevPaged = self.pagedOnLoad;

            if (event.state != null && event.state.faq) {
                prevPaged = event.state.paged;
            }

            self.showPageResults(prevPaged);
        });
    },

    /**
     * Fetch posts.
     *
     * @param {function} callbackDone   Function executed when the AJAX request is resolved
     * @param {function} callbackFail   Function executed when the AJAX request is rejected
     * @param {number}   paged          The targeted page
     */
    ajaxGetResults: function(callbackDone, callbackFail, paged) {
        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'faq.get_results',
                security: comedien.security,
                paged: paged,
                category: parseInt($('select#category').val()) || 0,
                subCategory: parseInt($('select#subCategory').val()) || 0,
            }
        }).done(callbackDone).fail(callbackFail);
    },
};

module.exports = new FrontFaqArchive();
